import { apiClient } from './api';
import {
  RegisterDto,
  LoginDto,
  RefreshTokenDto,
  AuthApiResponse,
  AuthResponseData,
  RefreshApiResponse,
  RefreshResponseData,
} from './auth.types';

export const authService = {
  /**
   * Register a new user and organization
   * POST /api/v1/auth/register
   */
  async register(dto: RegisterDto): Promise<AuthResponseData> {
    const response = await apiClient.post<any>('/api/auth/register', dto);
    return response.data.data || response.data;
  },

  /**
   * Login with email and password
   * POST /api/auth/login
   */
  async login(dto: LoginDto): Promise<AuthResponseData> {
    const response = await apiClient.post<any>('/api/auth/login', dto);
    return response.data.data || response.data;
  },

  /**
   * Refresh access token
   * POST /api/auth/refresh
   */
  async refresh(dto: RefreshTokenDto): Promise<RefreshResponseData> {
    const response = await apiClient.post<any>('/api/auth/refresh', dto);
    return response.data.data || response.data;
  },
};
